import { FaTwitter, FaLinkedin, FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';
import { FaLocationDot } from 'react-icons/fa6';
import logo from './assets/EximPe-White.svg';
import { Link } from 'react-router-dom';

export default function Footer() {
  // Social media links data
  const socialLinks = [
    { icon: <FaTwitter size={24} />, href: 'https://x.com/eximpe?lang=en', color: 'text-[#1DA1F2]' },
    { icon: <FaLinkedin size={24} />, href: 'https://www.linkedin.com/company/eximpe/?viewAsMember=true', color: 'text-[#0077B5]' },
    { icon: <FaFacebook size={24} />, href: 'https://www.facebook.com/eximpe/', color: 'text-[#1877F2]' },
    { icon: <FaInstagram size={24} />, href: 'https://www.instagram.com/exim.pe/?hl=en', color: 'text-[#E4405F]' },
    { icon: <FaYoutube size={24} />, href: 'https://www.youtube.com/channel/UCz_RGzYoiXQZ6WVwSRAVeYw', color: 'text-[#FF0000]' }
  ];

  // Company navigation links
  const companyLinks = [
    { text: 'About EximPe', href: '/about-eximpe' },
    { text: 'Request Demo', href: '/request-demo' },
    { text: 'Contact Us', href: '/contact-us' },
    { text: 'Support', href: 'https://eximpe.freshdesk.com/support/home' },
    { text: 'Grievance Redressal Policy', href: '/grievance-redressal-policy' }
  ];

  // Office locations data
  const locations = [
    '68 Circular Road, #02-01, 049422, Singapore',
    'WeWork Express Towers, Nariman Point, Marine Drive Mumbai, Maharashtra, India 400021',
    '1st Floor, 592, Nomads Centre, 1st Cross Rd, Santhosapuram, Koramangala 3 Block, Koramangala, Bengaluru, Karnataka 560034'
  ];

  // Legal links
  const legalLinks = [
    { text: 'Terms and Conditions', href: '/terms-and-conditions' },
    { text: 'Privacy Policy', href: '/privacy-policy' }
  ];

  // Scroll to top helper
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0 });
  };

  return (
    <footer className="bg-[#1a202c]  text-white py-8 px-4 md:px-8">
      {/* Main Footer Content - 3 columns on desktop */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-8 md:gap-16">
        {/* Left Column: Branding and Social Media */}
        <div className="flex-1">
          <Link to="/" onClick={scrollToTop}>
            <img src={logo} alt="EximPe Logo" className="w-40" />
          </Link>
          <p className="mb-6 mt-5">We Simplify Your Business</p>
          <div className="flex gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`${social.color} hover:text-gray-300 transition-colors`}
                aria-label={`Visit our ${social.icon.type.name} page`}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Middle Column: Company Links */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold mb-4">Company</h3>
          <nav aria-label="Company navigation">
            <ul className="flex flex-col space-y-2">
              {companyLinks.map((link, index) => (
                <li key={index}>
                  {link.href.startsWith('/') ? (
                    <Link
                      to={link.href}
                      onClick={scrollToTop}
                      className="hover:text-[#27a887] transition-colors"
                    >
                      {link.text}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-[#27a887] transition-colors"
                    >
                      {link.text}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Right Column: Contact Information */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold mb-4">Reach Us</h3>
          <address className="space-y-4 not-italic">
            {locations.map((location, index) => (
              <p key={index} className="flex items-start text-[#878b92]">
                <FaLocationDot className="inline-block mr-2 mt-1 w-4 h-4 flex-shrink-0" />
                {location}
              </p>
            ))}
          </address>
          <div className="mt-4 flex items-center text-[#878b92]">
            <IoMdMail className="inline-block mr-2 w-4 h-4 flex-shrink-0" />
            <a href="mailto:connect@eximpe.com" className="hover:text-[#27a887] transition-colors">
              connect@eximpe.com
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Section: Copyright and Legal Links */}
      <div className="max-w-7xl mx-auto mt-8 border-t border-gray-700 pt-4 flex flex-col md:flex-row justify-between items-center text-sm">
        <div className="mb-4 md:mb-0 text-[#878b92]">© 2025 Les Amis Private Limited</div>
        <nav aria-label="Legal navigation">
          <ul className="flex gap-4">
            {legalLinks.map((link, index) => (
              <li key={index}>
                <Link
                  to={link.href}
                  onClick={scrollToTop}
                  className="hover:text-[#27a887] transition-colors"
                >
                  {link.text}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  );
}
